import { render, staticRenderFns } from "./ModalHistory.vue?vue&type=template&id=79e9e9e2&"
import script from "./ModalHistory.vue?vue&type=script&lang=js&"
export * from "./ModalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports